(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/views/toplists/receiver-toplists-empty.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/views/toplists/receiver-toplists-empty.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.grassroots_shared=_svs.grassroots_shared||{};
_svs.grassroots_shared.templates=_svs.grassroots_shared.templates||{};
svs.grassroots_shared.templates.receiver_toplists_empty = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"padding-xs-1\">Kan inte ladda topplistan, försök igen senare.</div>";
},"useData":true});
Handlebars.partials['svs-grassroots_shared-receiver_toplists_empty'] = svs.grassroots_shared.templates.receiver_toplists_empty;
})(svs, Handlebars);


 })(window);